import React, { useEffect, useRef, useState } from "react";
import * as Styled from "./styles";
import DatePicker from "react-date-picker";
import { INITIAL_CHART_DATE } from "Helpers/consts";
import styled from "styled-components";
import { useFilters } from "Contexts/FiltersContext";

export interface IRangeDate {
  startDate: Date;
  endDate: Date;
}

interface Props {
  title?: string;
  name: string;
  initialStartDate?: Date;
  initialEndDate?: Date;
  changeStartDate(e: Date | null): void;
  changeEndDate(e: Date | null): void;
  maxDate?: Date;
  minDate?: Date;
  labelStartDate?: string;
  labelEndDate?: string;
  hideSearch?: boolean;
}

const StyledDatePicker = styled(DatePicker)`
  input {
    font-family: "Inter", sans-serif;
  }
`;

const RangeDateField: React.FC<Props> = ({
  title = "",
  name,
  initialStartDate = new Date(Date.now()),
  initialEndDate = new Date(Date.now() + 31536000000),
  changeStartDate,
  changeEndDate,
  maxDate = new Date(),
  minDate = new Date(INITIAL_CHART_DATE),
  labelStartDate = "De",
  labelEndDate = "Até",
  hideSearch,
}) => {
  const [startDate, setStartDate] = useState<Date | null>(initialStartDate);
  const [endDate, setEndDate] = useState<Date | null>(initialEndDate);
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState(0);
  const { registerResetFn } = useFilters();

  useEffect(() => {
    if (contentRef.current) {
      if (!hideSearch) {
        // Expand: calcula a altura real do conteúdo
        setMaxHeight(contentRef.current.scrollHeight);
      } else {
        // Collapse
        setMaxHeight(0);
      }
    }
  }, [hideSearch]);

  useEffect(() => {
    registerResetFn(() => {
      setStartDate(initialStartDate);
      setEndDate(initialEndDate);
      changeStartDate(initialStartDate);
      changeEndDate(initialEndDate);
    });
  }, []);

  return (
    <Styled.Field hideSearch={hideSearch} maxHeight={maxHeight}>
      {title && <Styled.Title>{title}</Styled.Title>}
      <div ref={contentRef} style={{ margin: "1px" }}>
        <Styled.Labels>
          <Styled.Label>
            <Styled.DateTile>{labelStartDate}</Styled.DateTile>
            <StyledDatePicker
              onChange={(date: Date | null) => {
                if (date === null && startDate === null) return;
                setStartDate(date);
                changeStartDate(date);
              }}
              value={startDate}
              name="start_date"
              // maxDate={maxDate}
              // minDate={minDate}
              format="dd/MM/yyyy"
              dayPlaceholder="DD"
              monthPlaceholder="MM"
              yearPlaceholder="AAAA"
            />
          </Styled.Label>
          <Styled.Label>
            <Styled.DateTile>{labelEndDate}</Styled.DateTile>
            <StyledDatePicker
              onChange={(date: Date | null) => {
                if (date === null && endDate === null) return;
                setEndDate(date);
                changeEndDate(date);
              }}
              value={endDate}
              name="end_date"
              // maxDate={maxDate}
              // minDate={minDate}
              format="dd/MM/yyyy"
              dayPlaceholder="--"
            />
          </Styled.Label>
        </Styled.Labels>
      </div>
    </Styled.Field>
  );
};

export default RangeDateField;
